import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '~shared/shadcn/ui/dialog';

interface CostumeImagePreviewDialogProps {
  imageUrl: string;
  performanceName?: string;
  children: React.ReactNode;
}

export const CostumeImagePreviewDialog = ({
  imageUrl,
  performanceName,
  children,
}: CostumeImagePreviewDialogProps) => {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className='max-w-4xl'>
        <DialogHeader>
          <DialogTitle>Costume Image Preview</DialogTitle>
          {performanceName && (
            <DialogDescription>{performanceName}</DialogDescription>
          )}
        </DialogHeader>
        <div className='flex items-center justify-center'>
          <img
            src={imageUrl}
            alt='Costume Image Preview'
            className='max-h-[70vh] w-auto rounded-lg object-contain'
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
